<template>
<div>
  <div class="employees__relative">

    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide class="employees" v-for="(employee, id) in getEmployees[departmentId]">
        <div class="employees__item">
          <div class="employees__flex">
            <div class="employees_image">
              <img :src="employee.photo" :alt="employee.last_name">
            </div>
            <div class="employees__content">
              <h3>
                {{ employee.first_name }} <br>
                {{ employee.last_name }}
              </h3>
              <p class="employees__position">
                {{ employee.position }}
              </p>
              <p v-if="employee.phone">
                tel.: <a :href="'tel:+48'+ employee.phone">{{ employee.phone }}</a>
              </p>
              <p v-if="employee.phone_mobile">
                tel. kom.: <a :href="'tel:+48'+ employee.phone_mobile">{{ employee.phone_mobile }}</a>
              </p>
              <p v-if="employee.email" class="employees__mail">
                <a :href="'mailto:' + employee.email">{{ employee.email }}</a>
              </p>
            </div>
          </div>
        </div>
      </swiper-slide>


    </swiper>
    <div class="swiper-button-prev" @click="prev"></div>
    <div class="swiper-button-next" @click="next"></div>
  </div>
  <!-- <div class="employees">
    <div class="employees__item" v-for="(employee, id) in getEmployees[departmentId]">
      <div class="employees__flex">
        <div class="employees_image">
          <img :src="employee.photo" :alt="employee.last_name">
        </div>
        <div class="employees__content">
          <h3>
            {{ employee.first_name }} <br>
            {{ employee.last_name }}
          </h3>
          <p class="employees__position">
            {{ employee.position }}
          </p>
          <p v-if="employee.phone">
            tel.: <a :href="'tel:+48'+ employee.phone">{{ employee.phone }}</a>
          </p>
          <p v-if="employee.phone_mobile">
            tel. kom.: <a :href="'tel:+48'+ employee.phone_mobile">{{ employee.phone_mobile }}</a>
          </p>
          <p v-if="employee.email" class="employees__mail">
            <a :href="'mailto:' + employee.email">{{ employee.email }}</a>
          </p>
        </div>
      </div>
    </div>
  </div> -->




</div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
export default {
  name: 'employees',
  props: ['departmentId'],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 10,
        autoplay: {
          delay: 3000,
        },
        // pagination: {
        //   el: '.swiper-pagination',
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          // when window width is >= 320px
          100: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          600: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 10
          },
        }
      }
    }
  },
  methods: {
    next: function next() {
      console.log(this.$refs.mySwiperRef);
      this.$refs.mySwiper.$swiper.slideNext()
    },
    prev: function prev() {
      this.$refs.mySwiper.$swiper.slidePrev()
    }
  },
  computed: {
    ...mapGetters([
      'getEmployees',
    ]),
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    console.log('Current Swiper instance object', this.swiper)
    this.swiper.slideTo(3, 1000, false)
  }
}
</script>
<style media="screen">

</style>
